




























import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VantivAccount } from '@/models/admin/store';
import { PaginationModel, VHeaders } from '@/models/pagedlistmodel';
import { VantivAccountListViewModel } from '@/models/payment/vantivAccount';
import { Base } from '@/components/common/base';
import { IDialogOption } from '@/models/dialog';
import {getVantiAccountHeaders} from '@/views/vantivaccount/vantiAccount';
import {storeService} from '@/shared';

@Component({
    props: ['methodName', 'progress'],
    computed: {
        methodtoCall: {
            get() {
                return this.$props.methodName;
            },
        },
    },
    components: {
        Stores: () => import( '@/components/common/store.select.vue'),
        Grid: (reolve) => import('@/components/common/app.grid.vue'),
        AppDialog: () => import('@/components/common/app.dialog.vue'),
    },
})
export default class VantivAccountTypeListPage extends Base {
    public headers: VHeaders[] = getVantiAccountHeaders(this);
    public vm: VantivAccountListViewModel = new VantivAccountListViewModel();
    public loading: boolean = false;
    public pagination = new PaginationModel('accountId');
    public search: string = '';
    public actions: any[] = [];
    public storeId: number;
    public pagedVantivAccounts: VantivAccount[] = [];

    public deleteDialog: IDialogOption = {
        width: 400,
        title: this.$parent.$t('vantivAccounts.deleteDialogTitle') as string,
        model: false,
        action: { color: 'success', icon: 'fas fa-check', text: 'Agree' },
        loading: false,
        onAction: (): void => {
            this.deleteVantivAccount();
        },
    };

    public accountToDelete: VantivAccount = {};
    public searched: boolean = false;
    public deleted: boolean = false;

    public created() {
        if (this.$route.params.storeId) {
            this.storeId = Number(this.$route.params.storeId);
        } else {
            this.storeId = this.userSession.storeId;
        }
    }

    public beforeDestroy() {
        const buttons = [];
        this.$emit('updateToolBar', buttons);
    }
    public callMethod(methodName): void {
        if (methodName === 'addVantivAccount') {
            this.$router.push({ name: 'admin.vantivaccounts.add', params: { storeId: this.storeId.toString() } });
        }
    }
    public updateToolBar(): void {
        const buttons: any = [];
        buttons.push({ id: '0', type: 'button', title: this.$t('vantivAccounts.btnAddVantivAccount'), disabled: false, visible: true, class: 'btn', label: this.$t('vantivAccounts.btnAddVantivAccount'), click: 'addVantivAccount', icon: 'fas fa-plus-circle' });
        this.$emit('updateToolBar', buttons);
    }
    public mounted() {
        // activating tab
        this.$root.$emit('sidebar.layout.vue', 'vantivAccounts');

        // Toolbar
        this.updateToolBar();
        this.$watch('methodtoCall', (newVal, oldVal) => {
            if (newVal) {
                this.callMethod(newVal);
            }
        });

        this.actions = [
            {
                type: 'link',
                icon: 'fas fa-edit',
                title: this.$t('vantivAccounts.vantivAccountGridHeaders.gridAction.edit') as string,
                action: (model: VantivAccount, storeId: string) => {
                    return {
                        name: 'admin.vantivaccounts.edit',
                        params: { storeId: this.storeId.toString(), type: model.type },
                    };
                },
            },
            {
                type: 'button',
                icon: 'fas fa-trash-alt',
                title: this.$t('vantivAccounts.vantivAccountGridHeaders.gridAction.delete') as string,
                color: 'error',
                action: (model: VantivAccount, storeId: string) => {
                    this.confirmDelete(model);
                },
            },
        ];
        if (!this.isAuthorizedToAccess(['SuperAdmin', 'T-Admin', 'E-Admin'])) {
            this.getVantivAccounts();
        }
    }

    public async getVantivAccounts(): Promise<void> {
        try {
            this.loading = true;
            const response = await storeService.getVantivAccounts(this.storeId);
            this.pagedVantivAccounts = response.results;
            this.pagination.totalItems = response.total;
        } finally {
            this.loading = false;
        }
    }

    public changeStore(storeId: number): void {
        this.storeId = storeId;
        this.getVantivAccounts();
    }
    public updatePaging(paging: any) {
        this.pagination = paging;
    }

    public confirmDelete(item: VantivAccount): void {
        this.deleteDialog.model = true;
        this.accountToDelete = item;
    }

    public async deleteVantivAccount(): Promise<void> {
        try {
            this.deleteDialog.loading = true;
            await storeService.deleteVantivAccount(
                this.storeId,
                this.accountToDelete.type,
            );
            this.showAlert(true, this.$t('vantivAccounts.alertDeleteVantivAccount'));
            this.deleteDialog.model = false;
            this.getVantivAccounts();
        } finally {
            this.deleteDialog.loading = false;
        }
    }
}
